import { useEffect, useState } from "react";
import { Typography, IconButton } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import "../../assets/style/PayMethod.css";

import { stringService } from "../../services/string.service";

export default function PayMethodCard({ method, onDelete }) {
  const isCard = method.type === "card";
  const [cardNumber, setCardNumber] = useState(method.card_number);
  const [cardDate, setCardDate] = useState(method.created_at);

  useEffect(() => {
    const cartNumberCut = () => {
      if (cardNumber) {
        const cardNumberShort = stringService.getLast4(cardNumber);
        setCardNumber(cardNumberShort);
      }
    };

    const cardDateFormat = () => {
      let cardDateFormat = cardDate;
      cardDateFormat = cardDateFormat.split("T")[0];
      setCardDate(cardDateFormat);
    };

    cartNumberCut();
    cardDateFormat();
  }, [method, cardNumber, cardDate]);

  return (
    <div className="payment-method-card">
      <div className="card-header">
        {isCard ? (
          <CreditCardIcon className="card-icon" />
        ) : (
          <AccountBalanceIcon className="card-icon" />
        )}
      </div>

      <div className="card-details">
        <Typography className="card-type-title">
          {isCard ? "Credit Card" : "Bank Account"}
        </Typography>
        <div>
          <Typography className="card-main-text">
            {isCard ? `${method.card_holder} *${cardNumber}` : method.bank_name}
          </Typography>
          <Typography className="card-date">{cardDate}</Typography>
        </div>
      </div>

      <IconButton
        className="delete-icon-button"
        onClick={() => onDelete(method.id, method.type)}
      >
        <DeleteOutlineIcon />
      </IconButton>
    </div>
  );
}
